import { render, staticRenderFns } from "./SellerBidCodeSnippet.vue?vue&type=template&id=87ea104c"
import script from "./SellerBidCodeSnippet.vue?vue&type=script&lang=js"
export * from "./SellerBidCodeSnippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports